import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import * as firebase from "firebase";
import Dice from "vue-dice-component";

Vue.config.productionTip = false;

Vue.use(Dice);

var config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_SENDER_ID,
  appId: process.env.VUE_APP_APP_ID
};
firebase.initializeApp(config);

const db = firebase.firestore();
// collection references
const usersCollection = db.collection("users");
const gamesCollection = db.collection("games");
const currentCollection = db.collection("current");
const auth = firebase.auth();


const route_path = [
  {
    name: "Select Funded",
    path: "/selectfunds"
  },
  {
    name: "Strategy Review",
    path: "/stratreview"
  },
  {
    name: "Roll Unfunded",
    path: "/portfolio"
  },
  {
    name: "Unfunded Review",
    path: "/unfundedreview"
  },
  {
    name: "Roll Funded",
    path: "/portfoliofunded"
  },
  {
    name: "Funded Review",
    path: "/fundedreview"
  },
  {
    name: "Pick Five Best",
    path: "/pickfive"
  },
  {
    name: "Best of 5 Review",
    path: "/bestfivereview"
  }
];

const init_items = [
  {
    text: "Pearl",
    icon: "mdi-nature",
    funded: false,
    result: null,
    value: null,
    success: 3,
    max_points: 20,
    prob_value: null,
    points: null,
    rolled: "",
    id: 0
  },
  {
    text: "Oyster",
    icon: "mdi-glass-wine",
    funded: false,
    result: null,
    value: null,
    success: 1,
    max_points: 20,
    prob_value: null,
    points: null,
    rolled: "",
    id: 1
  },
  {
    text: "Oyster",
    icon: "mdi-glass-wine",
    funded: false,
    result: null,
    value: null,
    success: 1,
    max_points: 20,
    prob_value: null,
    points: null,
    rolled: "",
    id: 2
  },
  {
    text: "Oyster",
    icon: "mdi-glass-wine",
    funded: false,
    result: null,
    value: null,
    success: 1,
    max_points: 20,
    prob_value: null,
    points: null,
    rolled: "",
    id: 3
  },
  {
    text: "Oyster",
    icon: "mdi-glass-wine",
    funded: false,
    result: null,
    value: null,
    success: 1,
    max_points: 20,
    prob_value: null,
    points: null,
    rolled: "",
    id: 4
  },
  {
    text: "Bread and Butter",
    icon: "mdi-calendar-range",
    funded: false,
    result: null,
    value: null,
    success: 3,
    max_points: 6,
    prob_value: null,
    points: null,
    rolled: "",
    id: 5
  },
  {
    text: "Bread and Butter",
    icon: "mdi-calendar-range",
    funded: false,
    result: null,
    value: null,
    success: 3,
    max_points: 6,
    prob_value: null,
    points: null,
    rolled: "",
    id: 6
  },
  {
    text: "Bread and Butter",
    icon: "mdi-calendar-range",
    funded: false,
    result: null,
    value: null,
    success: 3,
    max_points: 6,
    prob_value: null,
    points: null,
    rolled: "",
    id: 7
  },
  {
    text: "Bread and Butter",
    icon: "mdi-calendar-range",
    funded: false,
    result: null,
    value: null,
    success: 3,
    max_points: 6,
    prob_value: null,
    points: null,
    rolled: "",
    id: 8
  },
  {
    text: "White Elephant",
    icon: "mdi-map-marker",
    funded: false,
    result: null,
    value: null,
    success: 1,
    max_points: 6,
    prob_value: null,
    points: null,
    rolled: "",
    id: 9
  }
];

// firebase.getCurrentUser = () => {
//   return new Promise((resolve, reject) => {
//       const unsubscribe = firebase.auth().onAuthStateChanged(user => {
//           unsubscribe();
//           resolve(user);
//       }, reject);
//   })
// };

firebase.getCurrentUser = () => {
  const user = firebase.auth().currentUser;
  if (!user) return null;
  return {};
};

firebase.getAdmin = () => {
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        firebase
          .auth()
          .currentUser.getIdTokenResult()
          .then(idTokenResult => {
            // Confirm the user is an Admin.
            if (!!idTokenResult.claims.admin) {
              // Show admin UI.
              // alert(JSON.stringify(idTokenResult));
              resolve("Promise is resolved succesfuly");
            } else {
              reject;
            }
          });
      }
    });
  });
};

// firebase.getAdmin = () => {
//   return new Promise((resolve, reject) => {
//     const unsubscribe = firebase.auth().onAuthStateChanged(user => {
//       unsubscribe();

//     })
//   })
// }

// firebase.auth().currentUser.getIdTokenResult()
//           .then((idTokenResult) => {
//             // Confirm the user is an Admin.
//             if (!!idTokenResult.claims.admin) {
//               // Show admin UI.
//               alert(JSON.stringify(idTokenResult));
//             } else {
//               // Show regular user UI.
//               // showRegularUI();
//             }
//           })

export { db, usersCollection, init_items, gamesCollection, currentCollection, route_path };
export default firebase;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
